<template>
    <div class="container">
        <AccidentSearchForm />
    </div>
</template>
<script>
import AccidentSearchForm from '@/views/accident/components/AccidentSearchForm.vue'
export default {
    components: {AccidentSearchForm},
    mounted() {
      this.$store.commit('CLEAR_ACCIDENT_FULL_ORDER');
      this.$store.commit('CLEAR_ACCIDENT_INFO_OFFER');
      this.$store.commit('CLEAR_ACCIDENT_CONTRACT_ID');
      this.$store.commit('CLEAR_ACCIDENT_INFO_USER');
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
